export class TipoStrumentoAttuativo{
    id:number;
    descrizione:string;  
    cofinanziamento:boolean;  
}